import { ControlledInput } from '../form-controls';
import { useForm } from 'react-hook-form';
import '../../pages/login/login-page.css';

export type ForgotPasswordFormFields = {
  username: string;
};

interface ForgotPasswordFormProps {
  onSubmit: (data: ForgotPasswordFormFields) => void;
  error?: string; // Optional error property);
}

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onSubmit, error  }) => {
  const { handleSubmit, control } = useForm<ForgotPasswordFormFields>({
    defaultValues: {
      username: '',
    },
  });

  return (
    <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
      <ControlledInput
        control={control}
        name="username"
        rules={{ required: true }}
        inputProps={{ placeholder: 'Username', className: 'input-form', fullWidth: true }}
      />
      {error && (
        <p className="error-message" role="alert">
          {error}
        </p>
      )}
      <button className="login-submit" type="submit">
        Send Reset Link
      </button>
    </form>
  );
};
